import { postNullContent } from "src/lib/fetchData";
import { ProductCartModel } from "./types";

/*
context functions
*/
export function postAddToCart(model: ProductCartModel) {
  return postNullContent("/api/cart/additemtocart", {
    ProductId: model.ProductId,
    Quantity: model.Quantity,
    SelectedAttributes: model.Attributes.map((att) => {
      return {
        DetailId: att.DetailId,
        AttributeId: att.AttributeId,
        Name: att.Name,
      };
    }),
  });
}
